<div class="avatar" [class.with-extra]="extraInfo" #avatarContainer>
@if (showSkeletonWhileLoading && !photoResolved && (userId || employeeId)) {
	<p-skeleton
		shape="circle"
		[style.width.px]="size"
		[style.height.px]="size"
	></p-skeleton>
} @else if (fullImageUrl) {
	@if (enablePreview) {
		<p-image
			[src]="fullImageUrl"
			[alt]="name"
			[preview]="true"
			[previewImageSrc]="originalImageUrl || fullImageUrl"
			[appendTo]="'body'"
			imageClass="avatar-image"
			[imageStyle]="{ width: size + 'px', height: size + 'px', borderRadius: '50%', objectFit: 'cover', cursor: 'pointer' }"
			[pTooltip]="showTooltip ? name : ''"
			tooltipPosition="top"
		/>
	} @else {
		<img
			[src]="fullImageUrl"
			[alt]="name"
			class="avatar-image"
			[style.width.px]="size"
			[style.height.px]="size"
			[style.borderRadius]="'50%'"
			[style.objectFit]="'cover'"
			[style.cursor]="'default'"
			[pTooltip]="showTooltip ? name : ''"
			tooltipPosition="top"
		/>
	}
} @else if (name) {
    <div 
      class="avatar-initials"
      [style.width.px]="size"
      [style.height.px]="size"
      [pTooltip]="showTooltip ? name : ''"
      tooltipPosition="top"
    >{{ getInitials(name) }}</div>
  }
  @if (showInfo && (name || extraInfo)) {
    <div class="avatar-info">
      @if (name) {
        <span class="name">{{ name }}</span>
      }
      @if (extraInfo) {
        <span class="extra-info">{{ extraInfo }}</span>
      }
    </div>
  }
</div>
